import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { validateEnvironmentVariables } from './utils/environment';
import './components/charts/ChartRegistry'; // Import chart registry

// Validate environment variables before app initialization
validateEnvironmentVariables();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode><App /></StrictMode>
);